var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3250",
  "data-name": "Group 3250",
  transform: "translate(-440 -912)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_19",
  "data-name": "Ellipse 19",
  transform: "translate(440 912)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "dollar2",
  transform: "translate(335.411 914.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3248",
  "data-name": "Group 3248",
  transform: "translate(109.589 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M113.052,4.594V2.261a3.107,3.107,0,0,1,1.371.6.49.49,0,0,0,.272.086.57.57,0,0,0,.57-.563.506.506,0,0,0-.146-.358,3.493,3.493,0,0,0-2.073-.835V.4a.4.4,0,0,0-.4-.4h-.014a.411.411,0,0,0-.417.4V1.16a2.4,2.4,0,0,0-2.5,2.254c0,1.5,1.278,1.922,2.5,2.254V8.319a3.436,3.436,0,0,1-1.755-.775.551.551,0,0,0-.331-.119.577.577,0,0,0-.536.583.506.506,0,0,0,.146.358,3.9,3.9,0,0,0,2.483,1v.729s0,.009,0,.014a.41.41,0,0,0,.43.39.4.4,0,0,0,.4-.4V9.353a2.372,2.372,0,0,0,2.536-2.386C115.589,5.4,114.277,4.925,113.052,4.594Zm-.834-.212c-.722-.212-1.285-.431-1.285-1.047s.51-1.06,1.285-1.12Zm.834,3.95V5.919c.748.212,1.331.5,1.324,1.193C114.377,7.616,114.032,8.213,113.052,8.332Z",
  transform: "translate(-109.589 0)",
  fill: "#fff"
}))))));
export default __webpack_public_path__ + "static/media/payment_status_iconglobal.d2fd0ff5.svg";
export { SvgComponent as ReactComponent };